export const ROUTES = {
  login: "/login",
  authCallback: "/auth/callback",
  design: "/design",
  home: "/dashboard",
  storage: "/storage",
  agenda: "/agenda",
  tasks: "/tasks",
  settings: "/settings",
  classPattern: "/class/:id",
  classPrefix: "/class/",
  classOf: (id: string) => `/class/${id}`,
} as const;

export const LEGACY_ROUTES: ReadonlyArray<readonly [string, string]> = [
  ["/tableau-de-bord", ROUTES.home],
  ["/mon-stockage", ROUTES.storage],
  ["/mon-agenda", ROUTES.agenda],
  ["/mes-taches", ROUTES.tasks],
  ["/parametres", ROUTES.settings],
];

export const LEGACY_CLASS_PATTERN = "/classe/:id";
